import React, { useCallback, useState, useEffect } from 'react';
import apiFetch from '@wordpress/api-fetch';
import { Modal } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import { ReactComponent as Search } from '../assets/search.svg';
import clsx from 'clsx';
import style from './style.module.scss';

const labels = {
    documentation: 'Documentation',
    event: 'Événement',
    toolbox: 'Boite à outils',
    post: 'Article',
    partner: 'Partenaire',
    elu: 'Elu',
    page: 'Page',
    custom_blog: 'Blog',
};

export const SearchBar = ({ searchOpened, setSearchOpened, searchSubTypes, customSettings }) => {
    const [searchResults, setSearchResults] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSearch = useCallback(
        (event) => {
            setSearchInput(event.target.value);
        },
        [setSearchInput],
    );

    useEffect(() => {
        const delaySearch = setTimeout(() => {
            setSearchText(searchInput);
        }, 800);

        return () => clearTimeout(delaySearch);
    }, [searchInput]);

    useEffect(() => {
        if (!searchText.length || !searchSubTypes.length || !Object.keys(customSettings).length) return;
        setLoading(true);
        let params = {
            per_page: -1,
            type: 'post',
            subtype: searchSubTypes,
            search: searchText,
        };

        const urlParams = new URLSearchParams(params);

        apiFetch({
            path: '/wp/v2/search?' + urlParams.toString(),
            method: 'GET',
        })
            .then((data) => {
                const dataRewrite = data.map((item) => {
                    if (item.subtype === 'elu') item.url = customSettings.urlElu;
                    if (item.subtype === 'partner') item.url = customSettings.urlPartner;
                    if (item.subtype === 'toolbox') item.url = customSettings.urlTools;
                    return item;
                });
                setSearchResults(dataRewrite);
                setLoading(false);
            })
            .catch((err) => {
                console.error(err);
            });
    }, [customSettings, searchSubTypes, searchText]);

    return (
        <Modal open={searchOpened} onClose={() => setSearchOpened(false)} className={style.modal}>
            <div className={clsx(style.search, searchOpened && style.open)}>
                <div className={style.searchBar}>
                    <div class={style.bar}>
                        <Search className={style.icon} />
                        <input
                            type="text"
                            placeholder="Recherche"
                            onChange={handleSearch}
                            value={searchInput}
                            className={style.input}
                            autoFocus={true}
                        />
                    </div>
                </div>
                {loading &&
                    Array.from(new Array(3)).map((e, i) => (
                        <Skeleton key={i} className={style.skeleton} variant="rect" />
                    ))}
                {!loading && searchText.length > 0 && (
                    <>
                        <p className={style.resultsTitle}>
                            {searchResults.length > 0 ? 'Résultats (' + searchResults.length + ')' : 'Aucun résultat'}
                        </p>
                        <ul className={style.resultsList}>
                            {searchResults.map((searchResult, i) => (
                                <li className={style.result} key={i}>
                                    <a href={searchResult.url} className={style.link}>
                                        <span
                                            className={style.title}
                                            dangerouslySetInnerHTML={{ __html: searchResult.title }}
                                        />
                                        <span className={style.subtype}>{labels[searchResult.subtype]}</span>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </>
                )}
            </div>
        </Modal>
    );
};
